import { queryOptions } from '@tanstack/react-query'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import { getSportsTermSearch } from '@mobi/sports-offering/helpers/api/termSearch'
import { queryClient } from '@core/Data/ReactQuery'

const enum LocalConstants {
  CacheTime = 1_000 * 60 * 1, // 1min
}

export const sportsSearchQuery = ({
  searchTerm,
  isEnabled,
}: {
  searchTerm: string
  isEnabled: boolean
}) => {
  const queryKey = [...queryKeys.searchSportsBase, searchTerm]
  return queryOptions({
    queryKey,
    queryFn: () => getSportsTermSearch(queryClient, searchTerm, queryKey, LocalConstants.CacheTime),
    staleTime: LocalConstants.CacheTime,
    gcTime: LocalConstants.CacheTime,
    enabled: isEnabled && !!searchTerm && searchTerm.length > 2,
  })
}
